import '@engine/lib/plugins/jquery.entitysearch';
import { exists } from '@engine/lib/utility/exists';
import { jqueryCssInit } from '@engine/features/toggle_booleans';
import refreshComponent from '@engine/features/refresh_component';

function highlightContent(content) {
  $('.for_highlight').highlight(content);
}

function unhighlightContent() {
  $('.for_highlight').removeHighlight();
}

function applyHightlightForQuickSearches() {
  if ($('input.quick-search').val()) {
    highlightContent($('input.quick-search').val());
  }
}

function enableSearchComponents() {
  if (exists('#quick-search form')) {
    $('#quick-search form').entitysearch({
      callback: function callback() {
        var componentsToRefresh = ['ExportToolbar', 'UserEnabled', 'UserLoginEnabled'];
        applyHightlightForQuickSearches();
        jqueryCssInit();
        componentsToRefresh.map(function (component) {
          return refreshComponent(component);
        });
      }
    });
  }
}

function listenForResetButton() {
  $('input[type=reset]').on('click', function () {
    $('input[type=text]').each(function () {
      this.defaultValue = '';
    });
    this.form.reset();
    unhighlightContent();
    $('input:checkbox').prop('checked', false);
    $('input:radio').prop('checked', false);
    $('select option:selected').attr('selected', false);
    $('select').trigger('chosen:updated');
  });
}

export { enableSearchComponents, applyHightlightForQuickSearches, listenForResetButton };